(() => {
  if (typeof NodeList.prototype.forEach === 'function') return false
  NodeList.prototype.forEach = Array.prototype.forEach
})()



// WEBPACK FOOTER //
// ./app/polyfils/node_list_for_each.js